import { useEffect, useState } from "react"
import constants from "../../constants/constants"
import { LogView, Note, Pdf, Reload } from "../../assets/images/svg/icon"
import InvoiceOfUser from "./invoiceOfUser"
import { Info } from "@material-ui/icons"
import { Modal } from "react-bootstrap"
import { ErrorToast, InfoToast } from "../../shared"
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import { faGalacticSenate } from "@fortawesome/free-brands-svg-icons"
import ChangeReturnRevoke from "./revokeReturn/changeReturnRevoke"
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from '@material-ui/core/styles';
import { getMoadianLog, resendInvoice } from "../../api/requestAxios/invoice"
import ModalLogMoadian from "./modalLogMoadian"

const useStyles = makeStyles({
    tooltip: {
        background: '#171616',
        borderRadius: '20px ',
        color: '#FFF',
        padding: '8px 15px',
        fontSize: '14px'
    },
});

const AcceptedInvoice = ({
    item,
    setItemForDownload,
    setColumns,
    columns,
    data,
    setData,
    setItemInLoading,
    itemInLoading,
    setResendItemInLoading,
    resendItemInLoading,
    type
}) => {

    const [strOption, setStrOtion] = useState('')
    const [showPdf, setShowPdf] = useState(false)
    const [myId, setMyId] = useState('')
    const [showLog, setShowLog] = useState(false)
    const [modalHeader, setModalHeader] = useState('')
    const [modalContent, setModalContent] = useState('')
    const [infoClick, setInfoClick] = useState(false)
    const [loading, setLoading] = useState(false)


    const classesToolTip = useStyles();





    useEffect(() => {
        setStrOtion('')
        let typeInvoice = ''
        switch (item.OfficialFactorType) {
            case 1:
                typeInvoice = constants.AcceptedFactor
                break;
            case 3:
                typeInvoice = constants.Return
                break;
            case 4:
                typeInvoice = constants.ReservedFactor
                break;
            default:
                typeInvoice = ''


        }
        let creator = item.CreatorNameAndFamily ? item.CreatorNameAndFamily : '---'
        setStrOtion(typeInvoice + ' ' + constants.By + ' ' + creator + ' ' + '')

    }, [])
    //******************************************************************************** */
    const downloadFactoeUser = (type) => {
        if (type) {
            setItemInLoading(item.idTable)
        }
        else {
            setItemInLoading('')
        }
    }
    //********************************************************************************* */

    const resend = async () => {
        setLoading(true)
        setResendItemInLoading(item.idTable)
        try {
            const res = await resendInvoice(item?.OfficialFactorType === 3 ? item?.OfficialFactorId : item?.InvoiceId)
            if (res.data.result) {
                InfoToast(res.data.message)
                setLoading(false)
            }
            else {
                ErrorToast(res.data.message)
                setLoading(false)
            }
            setResendItemInLoading('')

        }
        catch {
            setResendItemInLoading('')
            ErrorToast('سرور به مشکل مواجه است')
            setLoading(false)

        }

    }

    const infoViewFn = () => {
        setInfoClick(true)
        setModalHeader('خطای سامانه مودیان')
        setModalContent(item?.MoadianLog)
        setShowLog(true)
    }

    const handleClose = () => {
        setShowLog(false)
    }


    const logViewFn = () => {
        setInfoClick(false)
        setModalHeader('خروجی سامانه مودیان')
        getLogView()
    }

    const getLogView = async () => {
        setLoading(true)
        try {
            let res = await getMoadianLog({ InvoiceId: item?.InvoiceId });

            if (res.data.ResultStatus === 1) {
                setModalContent(res.data?.moadianLogOutput?.MoadianHeader)
                setShowLog(true)
                setLoading(false)

            }
            else if (res.data.ResultStatus === 3) {
                ErrorToast(res.data.Message)
                setLoading(false)
            }


        }
        catch {
            setLoading(false)
            ErrorToast('سرور با مشکل مواجه است')
        }
    }

    const viewFactorFn = () => {
        setShowLog(true)
    }
 

    return (
        <>

            {type === "status" && <div>
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && item?.MoadianStatus === 'SUCCESS' &&
                    <div className='d-flex justify-content-between movadian-accept-color'>
                        <span>تایید شده</span>
                        <span className='action-icon' onClick={() => { logViewFn() }}><LogView /></span>
                    </div>}
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && item?.MoadianStatus === 'FAILED' &&
                    <div className='d-flex justify-content-between movadian-reject-color'>
                        <span>رد شده</span>
                        <span className='action-icon' onClick={() => { logViewFn() }}><LogView /></span>
                        <span className='action-icon' onClick={() => { infoViewFn() }}><Info /></span>
                        {
                            <>
                                {resendItemInLoading !== item.idTable && <span onClick={() => resend(item?.InvoiceId)}><Reload /></span>}
                                {resendItemInLoading === item.idTable && <div className='table-context-invoice'>
                                    <div className='table-loading-invoice'>
                                        <div className="spinner-border" role="status" aria-hidden="true"></div>
                                    </div>
                                </div>}
                            </>
                        }

                    </div>}
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && (item?.MoadianStatus !== 'FAILED' && item?.MoadianStatus !== 'SUCCESS') &&
                    <div className='d-flex justify-content-between movadian-pending-color'>
                        <span>در حال بررسی</span>
                    </div>
                }
                {(item?.MoadianStatus === null || item?.MoadianStatus === '') && (item?.MoadianTaxId === null || item?.MoadianTaxId === '') &&
                    <>
                        {resendItemInLoading !== item.idTable &&
                            <div className='d-flex justify-content-center movadian-pending-color'>
                                <span>درانتطار بررسی</span>
                                <span className='action-icon' onClick={() => resend(item?.InvoiceId)}><Reload /></span>
                            </div>}
                        {resendItemInLoading === item.idTable && <div className='table-context-invoice'>
                            <div className='table-loading-invoice'>
                                <div className="spinner-border" role="status" aria-hidden="true"></div>
                            </div>
                        </div>}
                    </>
                }
            </div>}

            {!type &&
                <>

                    <div className="d-flex justify-content-end  align-items-center">
                        {item?.MoadianStatus === 'SUCCESS' && item.StatusEn !== 'ReturnRevoke' && <ChangeReturnRevoke item={item} />}
                        {itemInLoading !== item.idTable &&
                            ((item.StatusEn === 'ReturnRevoke' && item?.Revoked) || (item.StatusEn !== 'ReturnRevoke')) &&
                            <Tooltip title={strOption} classes={classesToolTip}>
                                <span className="pdf-margin" onClick={() => downloadFactoeUser(true)}><Pdf /></span>
                            </Tooltip>
                        }
                        {item.StatusEn === 'ReturnRevoke' && <span onClick={(e) => { viewFactorFn(e) }}  ><Note /></span>}
                    </div>
                    {itemInLoading === item.idTable && <div className='table-context-invoice'>
                        <div className='table-loading-invoice'>
                            <div className="spinner-border" role="status" aria-hidden="true"></div>
                        </div>
                    </div>}
                    {itemInLoading === item.idTable && <InvoiceOfUser itemOfTable={item} setShowPdf={() => setItemInLoading(false)} />}
                    {/* {<p>{itemInLoading === item.idTable?'true':'false'}</p>} */}
                </>}

            {showLog &&
                <ModalLogMoadian
                    item={item}
                    showLog={showLog}
                    loading={loading}
                    modalContent={modalContent}
                    handleClose={handleClose}
                    modalHeader={modalHeader}
                    infoClick={infoClick}
                />}

        </>
    )
}

export default AcceptedInvoice